import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ModalDialogComponent } from 'src/app/components/modals/modal-dialog/modal-dialog.component';
import { EntryNote, EntryNoteDetail } from 'src/app/models/entry-note';
import { ResponseObject } from 'src/app/models/response-object.model';
import { EntryNoteService } from 'src/app/services/entry-note.service';

@Component({
  selector: 'app-entry-note-details',
  templateUrl: './entry-note-details.component.html',
  styleUrls: ['./entry-note-details.component.scss']
})
export class EntryNoteDetailsComponent {
  @Output() close = new EventEmitter<boolean>();
  @Input() noteId: number;
  @Input() note: EntryNote;
  @Output() closed = new EventEmitter<boolean>();
  @Input() showModal: boolean = false;

  entryNoteDetails: EntryNoteDetail[] = [];
  entryNoteData: EntryNote = null;

  constructor(
    private toastService: ToastrService,
    private entryNoteService: EntryNoteService
  ) { }

  ngOnInit(): void {
    this.getDetails();
  }

  getDetails() {
    if (!this.noteId) {
      return;
    }
    this.entryNoteService.getEntryNoteById(this.noteId).subscribe({
      next: (response: ResponseObject) => {
        this.entryNoteData = response.data;
        this.entryNoteDetails = response.data.details;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener los detalles de la nota de entrada", "Error");
      }
    });
  }

  formatDate(date: any): Date {
    return new Date(date);
  }

  closeModal(modal: ModalDialogComponent) {
      modal.onClose();
      this.closed.emit(false);
    }

  closedCreateNote() {
    this.closed.emit(false);
    this.showModal = false;
  }

}
